module.exports = "/076c958321237351e457a25f1551005dcff1e8fc/e9049f5e7574edf1dbc63410dd94e9e9.svg";